var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.content.fields && _vm.content.fields.length
    ? _c(
        "form",
        {
          ref: "form",
          staticClass: "feedback-form",
          attrs: {
            method: "post",
            "data-ya-metrica-goal": _vm.ya_metrica_goal
          },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.sendForm($event)
            }
          }
        },
        [
          _vm._l(_vm.content.fields, function(field) {
            return _c(
              "form-field",
              _vm._b(
                {
                  key: field.name,
                  staticClass: "feedback-form__field",
                  attrs: {
                    invalid: _vm.invalid[field.name],
                    clear: _vm.isClear
                  }
                },
                "form-field",
                field,
                false
              )
            )
          }),
          _c("form-file", {
            attrs: {
              label: _vm.content.file.label,
              name: "files",
              invalid: _vm.invalid["files"],
              clear: _vm.clearFile
            },
            on: { change: _vm.onFileChange }
          }),
          _c(
            "btn",
            {
              staticClass: "btn btn--primary feedback-form__submit",
              attrs: { tag: "control" }
            },
            [_vm._v(_vm._s(_vm.submitText))]
          ),
          _c(
            "form-checkbox",
            _vm._b(
              { staticClass: "feedback-form__checkbox" },
              "form-checkbox",
              _vm.content.checkbox,
              false
            )
          ),
          _c(
            "page-overlay",
            {
              attrs: {
                show: _vm.isModalShowed,
                width: 588,
                "auto-height": true
              },
              on: { close: _vm.closeForm }
            },
            [
              _c("div", { staticClass: "message" }, [
                _c("p", { staticClass: "message__text" }, [
                  _vm._v("Спасибо за заявку")
                ])
              ])
            ]
          )
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9a369778", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a369778","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/FeedbackForm.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-9a369778","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/FeedbackForm.vue
// module chunks = 0 1 2